define('views/invite/invite',[
    'backbone',
    'text!views/invite/invite.html',
    'views/_base/baseview',
    'models/invite/invite',
    'views/invite/invitationitem'
], function(Backbone, Template, BaseView, Invitation, InviteItem){
    'use strict';

    return BaseView.extend({
        template : _.template(Template),
        id       : 'invite-ff',
        isRender : true,
        needsAuth: true,
        activityIndicator: false,
        events   : {
            'input .md-input'             : 'handleMaterialInputLabelMODAL',
            'focus .md-input'             : 'clearInputValidationMODAL',
            'blur #email'                 : 'checkEmailMODAL',
            'submit'                      : 'sendInviteMODAL',
            'click #invite-form-submit'   : 'sendInviteMODAL',
            'click #invite-success-submit': 'closeMODAL',
            'click #invite-failed-submit' : 'closeMODAL',
            'click #pf-modal-close-btn'   : 'closeMODAL' // Add this reference for the Modal if using inheritance
        },
        initialize: function(options){
            options = options || {};
            this.elementName = options.elementName;
            this.formSubmitted = false;
            BaseView.prototype.initialize(this);
        },

        loadData: function(){},

        render: function(){
            this.$el.html(this.template());
            return this;
        },

        handleMaterialInputLabelMODAL: function(e){
            handleMDInputLabel( $(e.target) );
        },

        clearInputValidationMODAL: function(e){
            feedbackValid($(e.target), $(e.target).parent().find('.md-input-feedback') );
        },

        checkEmailMODAL: function(){
            var that = this,
                email = $('#email'),
                email_feedback = $('.js-md-input-feedback-email');
            // Delay validation check to see if user is trying to submit form to avoid conflict
            setTimeout(function(){
                if(!that.formSubmitted){
                    that.validateEmailMODAL(email, email_feedback);
                }
            },300);
        },

        sendInviteMODAL: function(e,that){
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = (that) ? that : this,
                first_name = that.$('#first_name'),
                first_name_feedback = that.$('.js-md-input-feedback-first_name'),
                last_name = that.$('#last_name'),
                last_name_feedback = that.$('.js-md-input-feedback-last_name'),
                email = that.$('#email'),
                email_feedback = that.$('.js-md-input-feedback-email'),
                form_feedback = false;

            that.patterns = Backbone.Validation.patterns;
            that.formSubmitted = true;

            $('#invite-form-submit').attr('disabled', true);
            $('#invite-form-submit').addClass('btn-showSpinner');

            if(!this.validateNameMODAL(first_name, first_name_feedback)){
                form_feedback = true;
            }
            if(!this.validateNameMODAL(last_name, last_name_feedback)){
                form_feedback = true;
            }
            if(!this.validateEmailMODAL(email, email_feedback)){
                form_feedback = true;
            }
            
            if(!form_feedback){

                var data = {
                    FN: first_name.val(),
                    LN: last_name.val(),
                    E : encrypt(email.val())
                };

                $.ajax({
                    type       : 'POST',
                    url        : pf.consumerURL + '/Invitation',
                    async      : false,
                    contentType: 'application/json',
                    data       : JSON.stringify(data),
                    success: function(modelStatus, respStatus, options){
                        
                        that.clearFormMODAL();
                        $('.js-invite-ff-form').fadeOut(function(){
                            $('.js-invite-ff-success').fadeIn();
                        });
                        
                        var time = moment().format(),
                            formatted_time = time.slice(0,time.lastIndexOf('-'));
                        
                        data.IDT = formatted_time;
                        
                        // Append to FF list
                        var invite_html = new InviteItem({ person: {
                            firstName : data.FN,
                            lastName  : data.LN,
                            invitedDT : data.IDT,
                            acceptedDT: null
                        } }).$el.html();

                        $('.js-invitation-list').prepend(invite_html);

                        that.resetFormMODAL(that);
                    },
                    error: function(modelStatus, respStatus, options){
                        // console.log('sendInviteMODAL error',modelStatus, respStatus, options);
                        $('.js-invite-ff-form').fadeOut(function(){
                            $('.js-invite-ff-failed').fadeIn();
                        });

                        that.resetFormMODAL(that);
                    }
                });

            } else {
                // Setting timeout here in case the email field blur timeout hasn't finished yet
                setTimeout(function(){
                    that.resetFormMODAL(that);
                },500);
            }
        },

        resetFormMODAL: function(that){
            that.formSubmitted = false;
            $('#invite-form-submit').attr('disabled', false);
            $('#invite-form-submit').removeClass('btn-showSpinner');
        },

        validateNameMODAL: function(item, item_feedback){
            var isValid = true;

            // validate first name
            if(item.val() == "" || !item.val() || !(item.val().length >= 2)){
                styleInputError(item);
                isValid = false;
            } else {
                styleInputValid(item);
            }
            // if either first or last are invalid
            if(isValid){
                removeErrorMsg(item_feedback);
                return true;
            } else {
                addErrorMsg(item_feedback, 'Enter at least 2 characters');
                return false;
            }
        },

        validateEmailMODAL: function(item, item_feedback){
            if(item.val() == "" || !item.val()){
                feedbackError(item, item_feedback, sysText['FV']['required']['email']);
                return false;
            } else if(!isEmail(item.val())){
                feedbackError(item, item_feedback, sysText['FV']['invalid']['email']);
                return false;
            } else {
                var return_value = false;
                $.ajax({
                    type   : 'POST',
                    async  : false,
                    url    : pf.userURL + '/SignUp',
                    data   : JSON.stringify({ Email:encrypt(item.val()) }),
                    contentType: 'application/json',
                    success: function (response) {
                        var Success = response.Success;
                        var SignUpEmailExists = response.SignUpEmailExists;
                        var userExists = response.userExists;

                        if (userExists == true) {

                            feedbackError(item, item_feedback, sysText['FV']['invalid']['emailExists']);
                            return_value = false;

                        } else if(SignUpEmailExists || Success){
                            
                            feedbackValid(item, item_feedback);
                            return_value = true;

                        }
                    },
                    error: function (response) {
                        return_value = false;
                    }
                });

                return return_value;
            }
        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        clearFormMODAL: function(that){
            var that = (that) ? that : this;
            that.$('#first_name').val('');
            that.$('#first_name').removeClass('md-input--filled');
            that.$('#last_name').val('');
            that.$('#last_name').removeClass('md-input--filled');
            that.$('#email').val('');
            that.$('#email').removeClass('md-input--filled');
            that.$('#phone').val('');
            that.$('#phone').removeClass('md-input--filled');
        },

        close: function(){}
    });
});

